import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { TxSerialized } from '@root/entities/transaction'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type {
  WalletGetTransferInstructionsCreatePayload,
  WalletSendTransferTransactionCreatePayload as WalletSendTransferTransactionCreatePayloadDto,
} from '@blade/trade-api-client'

export const getTransferInstructionsRequestAction = action(
  async (ctx, req: WalletGetTransferInstructionsCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(
        ctx,
        tradeApiClient.wallet.walletGetTransferInstructionsCreate,
        [
          {
            ...req,
          },
        ],
      ),
    )

    return pipe(
      result,
      Result.map((value) => ({
        ...value,
        tx: TxSerialized(value.serializedTx),
      })),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'getTransferInstructionsRequestAction',
)

interface WalletSendTransferTransactionCreatePayload
  extends WalletSendTransferTransactionCreatePayloadDto {}

export const sendTransferInstructionsRequestAction = action(
  async (ctx, req: WalletSendTransferTransactionCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(
        ctx,
        tradeApiClient.wallet.walletSendTransferTransactionCreate,
        [req],
      ),
    )

    return pipe(result, Result.mapError(ApiError.fallbackToUnknown))
  },
  'sendTransferInstructionsRequestAction',
)
